<template>
  <div id="tab2">
    <div class="row custom-container-search">
      <filter-list :rol-name="'rol'" :user-name="'user'" />
    </div>

    <tab-item-card :status-class="'green'">
      <div slot="body">
        <div class=" d-flex jusitfy-content-between  ">
          <div class="row col-12">
            <div class="col-3 p-0">
              <div class="d-flex flex-column">
                <span class="data-title">Nombre:</span>
                <span class="data-content">Johans Cuéllar</span>
              </div>
            </div>
            <div class="custom-information-divider" />
            <div class="col-2 p-0">
              <div class="d-flex flex-column">
                <span class="data-title">Usuario:</span>
                <span class="data-content">jcuellar</span>
              </div>
            </div>
            <div class="col-2 p-0">
              <div class="d-flex flex-column">
                <span class="data-title">Rol:</span>
                <span class="data-content">Admin</span>
              </div>
            </div>
            <div class="col-2 p-0">
              <div class="d-flex flex-column">
                <span class="data-title">Tipo de Propuesta:</span>
                <custom-drop-down
                  class="custom-drop-down"
                  :clearable="false"
                  fieldkey="id"
                  fieldname="description"
                  placeholder="Seleccione"
                />
              </div>
            </div>
            <div class="col-2 custom-container-provider p-0">
              <div class="d-flex flex-column">
                <span class="data-title">Tipo de Proveedores:</span>
                <custom-drop-down
                  class="custom-drop-down"
                  :clearable="false"
                  fieldkey="id"
                  fieldname="description"
                  placeholder="Seleccione"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div slot="actions">
        <action-button
          class="fr px-4 custom-btn-add"
          i="fa fa-times-circle"
          text="Añadir"
        />
      </div>
    </tab-item-card>
    <pagination class="custom-pagination" />
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';
import TabItemCard from './TabItemCard';
import Pagination from '@/components/common/Pagination';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import FilterList from './FilterList';

export default {
  name: 'Tab2',

  components: {
    ActionButton,
    TabItemCard,
    Pagination,
    CustomDropDown,
    FilterList,
  },
};
</script>

<style scoped>
.custom-search-button {
  float: right;
}

.custom-drop-down {
  width: 100%;
}

.custom-container-search {
  background: #f2f2f2;
  padding: 10px 5px;
  width: 99.6%;
  margin-left: 2px;
}

.custom-information-container {
  float: left;
  width: 100%;
  margin-top: 20px;
}

.custom-information {
  float: left;
}

.custom-information-data {
  background: #f2f2f2;
  float: left;
  padding: 25px 0px 25px 0px;
  border-left: 4px solid #2db782;
  border-radius: 5px;
}

.vgt-wrap {
  float: left;
  width: 100%;
}

.tag-badge-info {
  display: none !important;
}

.custom-information p {
  margin-bottom: 5px;
  font-size: 15px;
  color: #727272;
  font-weight: normal;
}

.custom-btn-add {
  border: 1px solid #2db782;
  color: #2db782;
  background: none;
  margin-top: 19px;
}

.custom-btn-add:hover {
  background-color: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}

.custom-information-divider {
  float: left;
  background: #72727230;
  width: 2px;
  height: 55px;
  position: absolute;
  margin-left: 160px;
}

.custom-information button {
  margin-top: 12px;
}

@media (max-width: 768px) {
  .custom-information-divider {
    margin-left: 96px !important;
  }
}

@media (max-width: 1024px) {
  .custom-information-divider {
    margin-left: 130px;
  }

  .custom-drop-down {
    width: 80%;
  }
}

.custom-pagination {
  float: left;
  width: 100%;
}

.custom-container-provider {
  float: left;
  margin-left: 60px;
}
</style>
